export var ElementsEnumerator = function (elementsClass) {
    this.elementsClass = elementsClass;
};
ElementsEnumerator.prototype.getElements = function () {    var elements = document.getElementsByClassName(this.elementsClass);
    var elementIdPrefix = this.elementsClass + "-";
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.setAttribute("id", (elementIdPrefix + (i + 1)));
    }    return elements;};